import Sidebar from '../utill/Sidebar'
import Header from "../utill/Header";
import Footer from "../utill/Footer";
import {Card, Table} from "react-bootstrap";
import React, {useContext, useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import styles from "../../css/Authority.module.css";
import {RootState} from "../../redux/store";

function AuthorityModify() {
    const url = useContext(Url)
    const navigate = useNavigate();
    const nowUser = useSelector((state: RootState) => state.user.value);
    const location = useLocation();
    const [advert, setAdvert] = useState({
        adName: '',
        goodsName: '',
        shoppingMallUrl: '',
        adDtm: '',
        goodsPrice: '',
        goodsDiscountPrice: ''
    });
    const [bannerImage, setBannerImage] = useState('');
    const [goodsImage, setGoodsImage] = useState('');


    const currentId = location.state?.id
    let userId = nowUser.id;
    const auth = useSelector((state: RootState) => state.loginAuth.value);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-고객사 수정'
        //@ts-ignore
        if (auth.MENUAUTH.AD0000.readAuthorityYn !== "1" && auth.MENUAUTH.AD0000.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        //@ts-ignore
        else if (auth.MENUAUTH.AD0000.writeAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다')
            navigate('/AdvertisingManagement')
        }
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'ad/view', {
                params: { id: currentId },
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setAdvert(response.data.result[0])
                })
            const nowBannerImage = async () => {
                try {
                    const resBannerImg = await axios.get( url + 'ad/bannerImage', {
                        params: { id: currentId },
                        responseType: 'arraybuffer',
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    });
                    if (resBannerImg){
                    const base64Banner = arrayBufferToBase64(resBannerImg.data);

                    setBannerImage(`data:image/jpeg;base64,${base64Banner}`)
                    }

                } catch (error) {
                    console.error('이미지를 불러오는데 실패했습니다.', error);
                }
            };

            const nowGoodsImage = async () => {
                try {
                    const resGoodsImg = await axios.get(url + 'ad/goodsImage', {
                        params: { id: currentId },
                        responseType: 'arraybuffer',
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    });
                    if (resGoodsImg) {
                        const base64Goods = arrayBufferToBase64(resGoodsImg.data);

                        setGoodsImage(`data:image/jpeg;base64,${base64Goods}`);
                    }
                } catch (error){
                    console.error('이미지를 불러오는데 실패했습니다.', error);
                }
            }

            const arrayBufferToBase64 = (buffer: Iterable<number>) => {
                return btoa(
                    new Uint8Array(buffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
                );
            };

            nowBannerImage();
            nowGoodsImage();
        })
    }, [currentId]);


    const handleModify = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            navigate('/AdvertisingModify', {
                state : {id: currentId}})
        })
    };

    const handleBackToManagement = () => {
        navigate('/AdvertisingManagement');
    }

    const handleDelete = async (e: React.MouseEvent<HTMLButtonElement>) => {
        reissue(userId, url, navigate).then(() => {
            e.preventDefault();
            const Delete = window.confirm(`광고를 삭제하시겠습니까?`);
            if (Delete) {
                try {
                    axios.post(url + 'ad/delete',{
                        id : currentId
                    }, {
                        headers: {
                            'Authorization': localStorage.getItem('Authorization')
                        }
                    }).then(res => {
                            alert('삭제 완료')
                            navigate('/AdvertisingManagement')
                        })
                } catch (e) {
                    console.error(e);
                    alert('삭제 실패 하였습니다.');
                }
            }
        })
    }


    return (
        <div id="wrapper">
            <Sidebar menuCode={"AD0000"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='광고 상세'/>
                        <Card className="card shadow mb-4">
                            <Card.Body>
                                <Table bordered>
                                    <tbody>
                                    <tr>
                                        <td className={styles.AdvertisingTableHead}><p>광고명</p></td>
                                        <td style={{width:"100%"}}>{advert.adName}</td>
                                    </tr>
                                    <tr>
                                        <td className={styles.AdvertisingTableHead}><p>상품명</p></td>
                                        <td style={{width:"100%"}}>{advert.goodsName}</td>
                                    </tr>
                                    <tr>
                                        <td className={styles.AdvertisingTableHead}><p>URL</p></td>
                                        <td style={{width:"100%"}}><a href={`${advert.shoppingMallUrl}`} target="_blank" rel="noopener noreferrer">{advert.shoppingMallUrl}</a></td>
                                    </tr>
                                    <tr>
                                        <td className={styles.AdvertisingImgTable}><p>배너 이미지</p></td>
                                        <td style={{width:"100%"}}>{bannerImage && <img style={{maxWidth:"800px", maxHeight:"250px"}} src={bannerImage} alt=""/>}</td>
                                    </tr>
                                    <tr>
                                        <td className={styles.AdvertisingImgTable}><p>상품 이미지</p></td>
                                        <td style={{width:"100%"}}>{goodsImage && <img style={{maxWidth:"400px", maxHeight:"400px"}} src={goodsImage} alt=""/>}</td>
                                    </tr>
                                    <tr>
                                        <td className={styles.AdvertisingTableHead}><p>광고 기간</p></td>
                                        <td style={{width:"100%"}}>{advert.adDtm ? advert.adDtm.replace(/\.0$/, '') : ''}</td>
                                    </tr>
                                    <tr>
                                        <td className={styles.AdvertisingTableHead}><p>상품 원가</p></td>
                                        <td style={{width:"100%"}}>{advert.goodsPrice}</td>
                                    </tr>
                                    <tr>
                                        <td className={styles.AdvertisingTableHead}><p>상품 할인가</p></td>
                                        <td style={{width:"100%"}}>{advert.goodsDiscountPrice}</td>
                                    </tr>
                                    </tbody>
                                </Table>
                                <div className="btn modify">
                                    <button className="btn btn-secondary" onClick={handleBackToManagement}>목록</button>
                                    <button className="btn btn-primary" onClick={handleModify}>수정</button>
                                    <button className="btn btn-danger" onClick={handleDelete}>삭제</button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    )
}

export default AuthorityModify;